import { create } from "zustand"

export const detailInfoStore = create(set => ({
  selectedRow: null,
  isOpen: false,

  openModal: (row) =>
    set({
      selectedRow: row,
      isOpen: true
    }),

  closeModal: () =>
    set({
      selectedRow: null,
      isOpen: false
    })
}))
